var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisaCreditCardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 18,
    viewBox: "0 0 33 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.451823,
    y: 0.166667,
    width: 31.991,
    height: 17.6667,
    rx: 1.16667,
    fill: "white",
    stroke: "#D9D9D9",
    strokeWidth: 0.333333
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0984 12.1927H8.14018L6.67175 7.64332C6.60205 7.43404 6.45406 7.24904 6.23637 7.16184C5.69311 6.94271 5.09447 6.76832 4.44141 6.68036V6.50521H7.59596C8.03134 6.50521 8.35787 6.76832 8.41229 7.07388L9.17419 10.3555L11.1315 6.50521H13.0353L10.0984 12.1927ZM14.1235 12.1927H12.2741L13.7969 6.50521H15.6463L14.1235 12.1927ZM18.0395 8.08179C18.0939 7.77546 18.4204 7.60031 18.8014 7.60031C19.4 7.55633 20.0521 7.64428 20.5964 7.86266L20.9229 6.63811C20.3787 6.46296 19.78 6.375 19.2368 6.375C17.4418 6.375 16.1357 7.16281 16.1357 8.25618C16.1357 9.08796 17.0609 9.5247 17.7139 9.78781C18.4204 10.0502 18.6926 10.2253 18.6381 10.4877C18.6381 10.8812 18.0939 11.0563 17.5507 11.0563C16.8976 11.0563 16.2445 10.9252 15.6468 10.706L15.3203 11.9313C15.9734 12.1497 16.6799 12.2377 17.333 12.2377C19.3456 12.2809 20.5964 11.4938 20.5964 10.3125C20.5964 8.82485 18.0395 8.73766 18.0395 8.08179ZM27.0685 12.1927L25.6 6.50521H24.0228C23.6962 6.50521 23.3697 6.68036 23.2608 6.94271L20.5417 12.1927H22.4455L22.8255 11.3617H25.1647L25.3823 12.1927H27.0685ZM24.2947 8.03906L24.838 10.1826H23.3151L24.2947 8.03906Z",
    fill: "#172B85"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisaCreditCardIcon);
export default __webpack_public_path__ + "static/media/visaCreditCardIcon.40dbc34c99e72e963d6d1919c9be41f3.svg";
export { ForwardRef as ReactComponent };